import { editableTableLib } from 'components/editable-table';

export const onEditClick = ({ form, record, setEditingKey }: editableTableLib.OnEditClickProps) => {
  form.setFieldsValue({ ...record });
  setEditingKey(record.key);
};

export const onEditCancel = ({ setEditingKey }: editableTableLib.OnEditCancelProps) => {
  setEditingKey('');
};

export const onEditSave = async ({
  form,
  mutationReq,
  setEditingKey,
  record,
}: editableTableLib.OnEditSaveProps) => {
  const values = form.getFieldsValue();
  await form.validateFields();
  await mutationReq({ id: record.key, ...values });

  setEditingKey('');
};
